<template>
  <MgdAlert
    v-if="!!session.adminProxy && !proxyNotificationDismissed"
    variant="warning"
  >
    <Icon name="lucide:triangle-alert" />
    <MgdAlertDescription class="flex flex-wrap items-center">
      <p>
        You are an acting on behalf account
        <span class="font-semibold">{{ session.adminProxy }}</span>
      </p>
      <div class="ms-auto flex flex-wrap justify-end gap-1">
        <MgdButton variant="outline" color="warning" size="sm" as-child>
          <NuxtLink to="/admin/act-as-account">Change Account</NuxtLink>
        </MgdButton>
        <MgdButton
          color="warning"
          size="sm"
          @click="proxyNotificationDismissed = true"
        >
          Dismiss
        </MgdButton>
      </div>
    </MgdAlertDescription>
  </MgdAlert>
</template>

<script setup lang="ts">
const { session } = useAppSession();

const proxyNotificationDismissed = useCookie<boolean>(
  "dismiss-proxy-notification",
  {
    default: () => true,
    encode: (value) => `${value}`,
    decode: (value) => value === "true",
  },
);
</script>
